module.exports = __webpack_public_path__ + "img/role.de4bdf1b.svg";